module.exports = __webpack_public_path__ + "img/duplex.67ad4da.png";